var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Kszta\\u0142t_1502",
    "data-name": "Kszta\\u0142t 1502",
    fillRule: "evenodd",
    d: "M0,0H20V2H0ZM0,6H20V8H0Zm0,6H20v2H0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoList);
export default __webpack_public_path__ + "static/media/videoList.bda241f0e453d4b318551ca7c4f3e510.svg";
export { ForwardRef as ReactComponent };